import { api } from '$$store/api';
import globalStore from '$$globalStore';
import app from '$$app';
import ganttViewModel from '$$ganttViewModel';
import timeTracking from '$$timeTrackingModel';
import projectComponent from '../../Project';
import _ from 'lodash';
import tasksHelpers from '$$store/tasks/helpers';
import timer from '../../../helpers/Timer';

// dataFromServer = {
//   resourcesToTask: [],
//   tasksData: { tasks:[],  customValues: {}},
//   timelogs: [],
//   teamColumns: [],
//   customFieldsToProject: [],
//   customFields: [],
//   customValues: [],
//   links: [],
// }
class UpToDate {
  constructor() {
    this.dataFromServer = null;
  }

  async updateClientDataByParams(params, changedTasks) {
    timer.start('timeToGetExternalData');
    const res = await api.post('/collaboration/dataByParams', params);

    timer.end('timeToGetExternalData');

    const data = res.data;

    this.dataFromServer = data;

    data.resourcesToTask && await this._updateTaskResources(data.resourcesToTask);
    data.tasksData && this._updateTasks(data.tasksData);
    data.customValues && this._updateCustomValuesOfTasks(data.customValues);
    data.customFields && this._updateCustomFields(data.customFields);
    data.customFieldsToProject && this._updateCustomFieldsInProjects(data.customFieldsToProject);
    data.teamColumns && this._updateCustomColumnsInTeam(data.teamColumns);
    data.timelogs && this._updateTimelogs(data.timelogs);
    data.links && this._updateLinks(data.links);

    this.dataFromServer = null;

    app.trigger('tasks:model:updateTask'); // for recalc workload

    data.resourcesToTask && app.trigger('refresh:filter');
  }

  async _updateTaskResources(data) {
    const tasksToUpdate = data.map(({ taskId, ganttId, resourcesToTask }) => ({
      id: +taskId,
      gantt_id: +ganttId,
      resources: _.cloneDeep(resourcesToTask),
    }));

    globalStore.commit('tasksModel/updateResourcesToTasks', { resourcesToTasks: data, fromGantt: false }, { root: true });
    globalStore.commit('tasksModel/updateTasks', { tasks: tasksToUpdate, fromGantt: false }, { root: true });
    globalStore.dispatch('headerView/setUIConfig');
  }

  _updateTasks(tasksData) {
    const customValuesMap = {};

    _.forEach(tasksData.customValues, (values, ganttId) => {
      if (!values?.items?.length) return;

      if (!customValuesMap[ganttId]) {
        customValuesMap[ganttId] = {};
      }

      _.forEach(values.items, item => {
        customValuesMap[ganttId][item.taskId] = item.updates;
      });
    });

    const tasksToUpdate = tasksData.tasks.map(t => {
      const task = tasksHelpers.prepareTaskData(t);
      const statusesAndPriority = _.get(customValuesMap, [task.gantt_id, task.id]);

      if (statusesAndPriority) {
        _.assign(task, statusesAndPriority);
      }

      return task;
    });

    globalStore.commit('tasksModel/updateCustomValues', { mapData: tasksData.customValues, fromGantt: false }, { root: true });
    globalStore.commit('tasksModel/updateTasks', { tasks: tasksToUpdate, fromGantt: false }, { root: true });
  }

  _updateCustomValuesOfTasks(values) {
    globalStore.commit('columns/updateUserCustomValues', { userCustomValues: values, fromGantt: false }, { root: true });

    const ganttIDs = ganttViewModel.getGanttIDs();

    app.trigger('userCustomColumnsModel:change', ganttIDs[0], 'update');
  }

  _updateCustomFields(columns) {
    columns.forEach(column => {
      globalStore.commit('columns/updateCustomColumn', { columnId: column.id, updated: { ...column } });
    });

    const ganttIDs = ganttViewModel.getGanttIDs();

    app.trigger('userCustomColumnsModel:change', ganttIDs[0], 'update');
  }

  _updateCustomFieldsInProjects(data) {
    data.forEach(el => {
      const storeCustomColumns = globalStore.getters['columns/getColumnIdsByProjectId'](+el.ganttId);

      if (storeCustomColumns.length > el.columnIds.length) {
        const deletedColumnIds = storeCustomColumns.filter(colId => !el.columnIds.includes(colId));

        if (deletedColumnIds.length) {
          deletedColumnIds.forEach(id => globalStore.commit('columns/removeColumnFromProjects', { columnId: id, projectIds: [+el.ganttId] }));
        }
      } else {
        globalStore.commit('columns/addColumnsToProjects', { columnIds: el.columnIds, projectIds: [+el.ganttId] });
      }
    });

    app.trigger('userCustomColumnsModel:change', [], 'update');
  }

  _updateCustomColumnsInTeam(columns) {
    globalStore.commit('columns/setCustomColumns', columns);
    app.trigger('userCustomColumnsModel:change');
  }

  _updateTimelogs(data) {
    Object.entries(data).forEach(([taskId, taskLogs]) => {
      const gantt_id = globalStore.getters['tasksModel/getTask'](+taskId).gantt_id;

      timeTracking.manualUpdateItemForTask({
        task_id: +taskId,
        gantt_id,
      }, taskLogs);
    });
  }

  _updateLinks(links) {
    const projects = [...new Set(links.map(i => i.gantt_id))];
    const projectsHasUser = projects.filter(id => projectComponent.userHasProject(id));

    const linksToCreate = [];
    const linksToUpdate = [];

    links.forEach(link => {
      if (!projectsHasUser.includes(link.gantt_id)) { return; }

      const modelLink = globalStore.getters['tasksModel/getLinkByGanttId'](link.gantt_id, link.id);
      const isExist = Object.keys(modelLink).length;

      if (isExist) {
        linksToUpdate.push(link);

        return;
      }

      linksToCreate.push(link);
    });

    if (linksToCreate.length) {
      globalStore.commit('tasksModel/addLinks', { links: linksToCreate, fromGantt: false }, { root: true });
    }

    if (linksToUpdate.length) {
      globalStore.commit('tasksModel/updateLinks', { links: linksToUpdate, fromGantt: false }, { root: true });
    }
  }
}

export default new UpToDate();
